module.exports = __webpack_public_path__ + "img/img-pm2.5.abd4a535.png";